import React from 'react';
import { ButtonGroup, Button } from 'react-bootstrap';
import {
  FaAngleDoubleLeft,
  FaAngleLeft,
  FaAngleRight,
  FaAngleDoubleRight,
  FaPlus,
  FaMinus,
  FaCheck,
  FaUndo,
  FaPen,
} from 'react-icons/fa';
import PropTypes from 'prop-types';

/**
 * Componente com botões de navegação e CRUD para dicionários
 * Botões: ⏮ ◀ ▶ ⏭ | ✏️ ➕ 🗑 | ✓ ↩
 */
export default function DicionarioNavButtons({
  onFirst,
  onPrevious,
  onNext,
  onLast,
  onEdit,
  onNew,
  onDelete,
  onSave,
  onCancel,
  isEditing = false,
  // isCreating = false,
  isSaving = false,
  disabled = false,
  totalItems = 0,
  currentIndex = 0,
}) {
  const navigationDisabled = disabled || isEditing || totalItems === 0;
  const editDisabled = disabled || isEditing || totalItems === 0;
  const newDisabled = disabled || isEditing;
  const deleteDisabled = disabled || isEditing || totalItems === 0;
  const saveDisabled = disabled || !isEditing || isSaving;
  const cancelDisabled = disabled || !isEditing;

  return (
    <div className="d-flex justify-content-center align-items-center flex-wrap gap-2">
      <ButtonGroup size="sm">
        <Button
          variant="outline-secondary"
          onClick={onFirst}
          disabled={navigationDisabled || currentIndex === 0}
          title="Primeiro registro"
          style={{ minWidth: 40 }}
        >
          <FaAngleDoubleLeft />
        </Button>
        <Button
          variant="outline-secondary"
          onClick={onPrevious}
          disabled={navigationDisabled || currentIndex === 0}
          title="Registro anterior"
          style={{ minWidth: 40 }}
        >
          <FaAngleLeft />
        </Button>
        <Button
          variant="outline-secondary"
          onClick={onNext}
          disabled={navigationDisabled || currentIndex >= totalItems - 1}
          title="Próximo registro"
          style={{ minWidth: 40 }}
        >
          <FaAngleRight />
        </Button>
        <Button
          variant="outline-secondary"
          onClick={onLast}
          disabled={navigationDisabled || currentIndex >= totalItems - 1}
          title="Último registro"
          style={{ minWidth: 40 }}
        >
          <FaAngleDoubleRight />
        </Button>
      </ButtonGroup>

      {/* Separador visual */}
      <span style={{ margin: '0 5px', color: '#ccc' }}>|</span>

      {/* Grupo de Edição */}
      <ButtonGroup size="sm">
        <Button
          variant="outline-primary"
          onClick={onNew}
          disabled={newDisabled}
          title="Novo registro"
          style={{ minWidth: 40 }}
        >
          <FaPlus />
        </Button>
        <Button
          variant="outline-warning"
          onClick={onEdit}
          disabled={editDisabled}
          title="Editar registro"
          style={{ minWidth: 40 }}
        >
          <FaPen />
        </Button>
        <Button
          variant="outline-danger"
          onClick={onDelete}
          disabled={deleteDisabled}
          title="Excluir registro"
          style={{ minWidth: 40 }}
        >
          <FaMinus />
        </Button>
      </ButtonGroup>

      {/* Separador visual */}
      <span style={{ margin: '0 5px', color: '#ccc' }}>|</span>

      {/* Grupo de Confirmação */}
      <ButtonGroup size="sm">
        <Button
          variant={isEditing ? 'success' : 'outline-success'}
          onClick={onSave}
          disabled={saveDisabled}
          title="Salvar alterações"
          style={{ minWidth: 40 }}
        >
          {isSaving ? (
            <span
              className="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            />
          ) : (
            <FaCheck />
          )}
        </Button>
        <Button
          variant={isEditing ? 'secondary' : 'outline-secondary'}
          onClick={onCancel}
          disabled={cancelDisabled}
          title="Cancelar edição"
          style={{ minWidth: 40 }}
        >
          <FaUndo />
        </Button>
      </ButtonGroup>

      {/* Indicador de posição */}
      {totalItems > 0 && (
        <span
          style={{
            marginLeft: 15,
            fontSize: '0.85rem',
            color: '#6c757d',
          }}
        >
          {currentIndex + 1} / {totalItems}
        </span>
      )}
    </div>
  );
}

DicionarioNavButtons.propTypes = {
  onFirst: PropTypes.func,
  onPrevious: PropTypes.func,
  onNext: PropTypes.func,
  onLast: PropTypes.func,
  onEdit: PropTypes.func,
  onNew: PropTypes.func,
  onDelete: PropTypes.func,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  isEditing: PropTypes.bool,
  isCreating: PropTypes.bool,
  isSaving: PropTypes.bool,
  disabled: PropTypes.bool,
  totalItems: PropTypes.number,
  currentIndex: PropTypes.number,
};
